import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enUS from './lang/en_US/common.json';
import esES from './lang/es_ES/common.json';
import frFR from './lang/fr_FR/common.json';
import deDE from './lang/de_DE/common.json';
import itIT from './lang/it_IT/common.json';
import ptPT from './lang/pt_PT/common.json';
import ruRU from './lang/ru_RU/common.json';
import caES from './lang/ca_ES/common.json';
import euES from './lang/eu_ES/common.json';

const resources = {
  en: { translation: enUS },
  es: { translation: esES },
  fr: { translation: frFR },
  de: { translation: deDE },
  it: { translation: itIT },
  pt: { translation: ptPT },
  ru: { translation: ruRU },
  ca: { translation: caES },
  eu: { translation: euES },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: navigator.language.split('-')[0], // Detecta idioma del navegador
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 